import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const notificacoesRepository = createRepository({
  path: 'notificacoes',
  restApi
})

notificacoesRepository.notificacoesAnalista = id => {
  return restApi.get(`notificacoes/analista/${id}`)
}

export default notificacoesRepository
